var map = {
	"./Index": [
		89142,
		975,
		387,
		142
	],
	"./Index.vue": [
		89142,
		975,
		387,
		142
	],
	"./coupon/Index": [
		99784,
		975,
		387,
		728,
		925,
		784
	],
	"./coupon/Index.vue": [
		99784,
		975,
		387,
		728,
		925,
		784
	],
	"./coupon/QrcodeComponent": [
		42925,
		925
	],
	"./coupon/QrcodeComponent.vue": [
		42925,
		925
	],
	"./mobile/AllYouCanEat": [
		25561,
		975,
		387,
		728,
		561
	],
	"./mobile/AllYouCanEat.vue": [
		25561,
		975,
		387,
		728,
		561
	],
	"./mobile/BookingTable": [
		57767,
		975,
		387,
		728,
		767
	],
	"./mobile/BookingTable.vue": [
		57767,
		975,
		387,
		728,
		767
	],
	"./mobile/BuyerInfoView": [
		95718,
		975,
		387,
		728,
		718
	],
	"./mobile/BuyerInfoView.vue": [
		95718,
		975,
		387,
		728,
		718
	],
	"./mobile/CartListView": [
		41027,
		975,
		387,
		728,
		27
	],
	"./mobile/CartListView.vue": [
		41027,
		975,
		387,
		728,
		27
	],
	"./mobile/Contact": [
		64816,
		975,
		387,
		728,
		816
	],
	"./mobile/Contact.vue": [
		64816,
		975,
		387,
		728,
		816
	],
	"./mobile/CustomView": [
		43098,
		975,
		387,
		728,
		98
	],
	"./mobile/CustomView.vue": [
		43098,
		975,
		387,
		728,
		98
	],
	"./mobile/FoodListView": [
		24740,
		975,
		387,
		728,
		740
	],
	"./mobile/FoodListView.vue": [
		24740,
		975,
		387,
		728,
		740
	],
	"./mobile/IndexView": [
		46426,
		975,
		387,
		728,
		426
	],
	"./mobile/IndexView.vue": [
		46426,
		975,
		387,
		728,
		426
	],
	"./mobile/OrderDetailsView": [
		46446,
		975,
		387,
		728,
		446
	],
	"./mobile/OrderDetailsView.vue": [
		46446,
		975,
		387,
		728,
		446
	],
	"./mobile/OrderSuccessView": [
		49905,
		975,
		387,
		728,
		905
	],
	"./mobile/OrderSuccessView.vue": [
		49905,
		975,
		387,
		728,
		905
	],
	"./mobile/TimeView": [
		76513,
		975,
		387,
		728,
		513
	],
	"./mobile/TimeView.vue": [
		76513,
		975,
		387,
		728,
		513
	],
	"./pages/AllYouCanEat": [
		12842,
		975,
		257,
		968,
		842
	],
	"./pages/AllYouCanEat.vue": [
		12842,
		975,
		257,
		968,
		842
	],
	"./pages/BookingTable": [
		58332,
		975,
		387,
		257,
		968,
		332
	],
	"./pages/BookingTable.vue": [
		58332,
		975,
		387,
		257,
		968,
		332
	],
	"./pages/BuyerInfoView": [
		4777,
		975,
		387,
		257,
		968,
		777
	],
	"./pages/BuyerInfoView.vue": [
		4777,
		975,
		387,
		257,
		968,
		777
	],
	"./pages/CartListView": [
		16274,
		975,
		387,
		257,
		968,
		274
	],
	"./pages/CartListView.vue": [
		16274,
		975,
		387,
		257,
		968,
		274
	],
	"./pages/Contact": [
		78646,
		975,
		387,
		257,
		968,
		646
	],
	"./pages/Contact.vue": [
		78646,
		975,
		387,
		257,
		968,
		646
	],
	"./pages/CustomView": [
		83489,
		975,
		257,
		968,
		489
	],
	"./pages/CustomView.vue": [
		83489,
		975,
		257,
		968,
		489
	],
	"./pages/IndexView": [
		44565,
		975,
		387,
		257,
		565
	],
	"./pages/IndexView.vue": [
		44565,
		975,
		387,
		257,
		565
	],
	"./pages/Login": [
		30756,
		975,
		257,
		968,
		756
	],
	"./pages/Login.vue": [
		30756,
		975,
		257,
		968,
		756
	],
	"./pages/Register": [
		79786,
		975,
		257,
		968,
		786
	],
	"./pages/Register.vue": [
		79786,
		975,
		257,
		968,
		786
	],
	"./results/PaymentFailed": [
		48989,
		975,
		257,
		989
	],
	"./results/PaymentFailed.vue": [
		48989,
		975,
		257,
		989
	],
	"./results/PaymentSuccess": [
		21578,
		975,
		387,
		257,
		578
	],
	"./results/PaymentSuccess.vue": [
		21578,
		975,
		387,
		257,
		578
	],
	"./takeaway02/Cart": [
		92265,
		975,
		265
	],
	"./takeaway02/Cart.vue": [
		92265,
		975,
		265
	],
	"./takeaway02/Checkout": [
		64379,
		975,
		387,
		630,
		879
	],
	"./takeaway02/Checkout.vue": [
		64379,
		975,
		387,
		630,
		879
	],
	"./takeaway02/Custom": [
		87355,
		975,
		387,
		630,
		355
	],
	"./takeaway02/Custom.vue": [
		87355,
		975,
		387,
		630,
		355
	],
	"./takeaway02/Delivery": [
		62261,
		975,
		387,
		261
	],
	"./takeaway02/Delivery.vue": [
		62261,
		975,
		387,
		261
	],
	"./takeaway02/Food": [
		9379,
		975,
		387,
		379
	],
	"./takeaway02/Food.vue": [
		9379,
		975,
		387,
		379
	],
	"./takeaway02/IndexView": [
		23772,
		975,
		387,
		630,
		772
	],
	"./takeaway02/IndexView.vue": [
		23772,
		975,
		387,
		630,
		772
	],
	"./takeaway02/OrderDetial": [
		71118,
		975,
		387,
		630,
		118
	],
	"./takeaway02/OrderDetial.vue": [
		71118,
		975,
		387,
		630,
		118
	],
	"./takeaway02/Search": [
		34151,
		151
	],
	"./takeaway02/Search.vue": [
		34151,
		151
	],
	"./takeaway02/SubFood": [
		5510,
		975,
		387,
		510
	],
	"./takeaway02/SubFood.vue": [
		5510,
		975,
		387,
		510
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 26968;
module.exports = webpackAsyncContext;